import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const TRCIcon = createIcon({
  displayName: 'TRCIcon',
  path: (
    <g>
      <svg id="TRCicon" data-name="TRC Icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 582.9 171.8">
        <path fill="#1a3f6f" d="M32 172h48l65-82H93l-61 82z" />
        <path fill="#3cae49" d="M145 82H94L32 0h49l64 82z" />
        <path fill="#1a3f6f" d="m30 45 14 18-15 19H0l30-37z" />
        <path fill="#3cae49" d="m30 127 14-19-15-18H0l30 37z" />
        <path fill="#123f6d" d="M309 22H189v25h47v112h27V47h46V22z" />
        <path fill="#123f6d" d="M703 187h-60c-21 0-39-18-39-40v-5c0-21 18-39 40-41h42V76h-40c-38 0-69 30-69 67v3c0 37 31 67 69 67h57Zm-138 26-42-53h2c18-1 32-20 32-42s-14-40-32-42h-69v26h64c7 0 13 8 13 17s-6 16-13 17h-91v77h27v-53h33l41 53Z" transform="translate(-120 -54)" />
      </svg>
    </g>
  )
})